/**
 * call 封装
 */
import {
  isFn,
  events,
  noop,
  ERR_OK,
  isStr,
  isUndefined,
  getWindow
} from '../util';
let theWindow = getWindow();

import {
  inApp,
  isAndroid,
  isFusionKit
} from '../global-api/app';

import {
  callIOS
} from './ios';

import {
  callAndroid
} from './android';

// 引入fusion支持
import Fusion from '../fusion/src/fusion';
// const Fusion = require('../fusion/fusion');

theWindow.Fusion = Fusion;
/**
 * 根据config创建JSBridge方法
 * @param conf 配置文件
 * @returns {Function}
 */
export function makeBridgeFn(name, conf) {
  return function (param = {}, callback = noop) {
    if (arguments.length === 1 && isFn(param)) {
      callback = param;
      param = {};
    }

    let fn = conf ? conf.fn : name;
    call(fn, param, callback);
  };
};

export function init() {
  let triggerName = '__bridgeTrigger__';

  theWindow[triggerName] = function (retData) {
    if (isStr(retData)) {
      try {
        retData = JSON.parse(retData);
      } catch (e) {
        retData = {};
      }
    }
    let eventName = retData.eventname;
    let errno = retData.errno;
    let err = null;
    if (errno !== ERR_OK) {
      let msg = retData.errmsg;
      err = new Error(msg);
    }
    events.emit(eventName, err, retData.result);
  };

  call('initConfig', {
    handler: triggerName
  }, noop);
}

function call(fn, param, callback) {
  if (inApp()) {
    if (isFusionKit() && !isUndefined(theWindow.Fusion) && !isUndefined(theWindow.Fusion[fn])) {
      let triggerName = '__fusionBridgeCall__';
      theWindow[triggerName] = function (ret) {
        if (ret) {
          let err = null;
          callback.length === 1 ? callback(JSON.stringify(ret)) : callback(err, ret);
        }
      };
      theWindow.Fusion[fn](param, theWindow[triggerName]);
    } else {
      if (isAndroid()) {
        callAndroid(fn, param, callback);
      } else {
        callIOS(fn, param, callback);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/core/bridge.js